import General from './General'
import Payment from './Payment'
import Question from './Question'
import PetRestore from './PetRestore'
import Product from './Product'
import Tax from './Tax'
import Iframe from './Iframe'
import KennelCard from './KennelCard'
import InPerson from './InPerson'
import Kiosk from './Kiosk'
import LimitControl from './LimitControl'
import ProcessTag from './ProcessTag'
import Characteristics from './Characteristics'
import PetProfile from './PetProfile'
import DiscountReason from './DIscountReason'

export default {
  General,
  Payment,
  Question,
  PetRestore,
  Product,
  Tax,
  Iframe,
  KennelCard,
  InPerson,
  Kiosk,
  LimitControl,
  ProcessTag,
  Characteristics,
  PetProfile,
  DiscountReason
}
